import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/notifications', [
    {
      path: '',
      name: 'notification',
      component: () => import('@/views/notifications/NotificationList.vue'),
    },
    {
      path: '/create',
      name: 'notification-create',
      component: () => import('@/views/notifications/NotificationCreate.vue'),
    },
    {
      path: '/:id(\\d+)?',
      name: 'notification-edit',
      component: () => import('@/views/notifications/NotificationEdit.vue'),
    },
  ]);
};
